import { createSlice } from '@reduxjs/toolkit';
import { AppDispatch } from '../Store';
import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import * as AdministrationRoute from '../route/administrationRoute';
import Alert from '../../utils/Alert/Alert';
import moment from 'moment';

export interface AxiosError<T = any> extends Error {
  config: AxiosRequestConfig;
  code?: string;
  request?: object;
  data: object;
  response?: AxiosResponse<T>;
  isAxiosError: boolean;
  toJSON: () => object;
}

const initialState = {
  getCourseAdministration: [],
  loading: false,
};

let cancelGetStudentsByCourse: any;

const getStudentsByCourse =
  (id: string, params: any) => async (dispatch: AppDispatch) => {
    return AdministrationRoute.getStudentsByCourse(id)
      .then((res: AxiosResponse) => {
        if (res?.data) {
          const { records, totCount } = res?.data;
          if (!records?.length) {
            params.api.showNoRowsOverlay();
          } else params.api.hideOverlay();
          return params.success({
            rowData: records,
            rowCount: totCount || 0,
          });
        }
      })
      .catch((err: AxiosError) => {
        params.fail();
      });
  };

const getReportsData = (id: any) => {
  const asdf = async (html: any) => {
    await axios
      .post(`${process.env.REACT_APP_PDF_MAKER_URL}/api/generate/pdf`, {
        data: {
          html: html,
        },
      })
      .then((response: any) => {
        //view pdf
        const byteCharacters = atob(response.data.buffer);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });

        // Create a data URL for the Blob
        const pdfUrl = URL.createObjectURL(pdfBlob);

        // Open the PDF in a new tab
        window.open(pdfUrl, '_blank');

        // Revoke the URL after opening the new tab
        URL.revokeObjectURL(pdfUrl);
      });
  };

  return AdministrationRoute.getReports(id)
    .then((res: AxiosResponse) => {
      if (res?.data) {
        if (res.data) {
          const base64ImgString =
            'data:image/png;base64,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';
          const html = ` <main>
  <header style="border-top-width: 4px;
              border-bottom-width: 4px; 
                 border-block-style: solid;
              border-color: rgb(120 113 108); 
                ">
    <div style="display: flex; align-items: center; justify-content: space-around;">
      <img src=${base64ImgString} style="width: 80px; height: auto;" alt="logo" />
      <div style="text-align:center">
         <h1 style="font-size:40px; margin-bottom: 5px">LASSO Report</h1>
         <small>
           A product of the Learning Assistant Alliance
         </small>
      </div>
      <img src=${base64ImgString} style="width: 80px; height: auto;" alt="logo" />
    </div>

    <div style="display: flex; justify-content: space-between">
      <p style="font-size: 14px;">contact@learningassistantalliance.org</p>
     
      <p style="font-size: 14px;">https://learningassistantalliance.org</p>
    </div>
  </header>
  
  <article>
    <div style="display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); margin-top: 40px; margin-left: 80px;
    margin-right: 80px;  border-bottom-width: 2px; border-color: rgb(203, 213, 225); font-size: 14px;
    line-height: 20px;">
      <label style="padding: 4px;  width: 224px">Assessment:</label>
      <label style="padding: 4px;">${res.data.reportsData[0].assessment}</label>
      <label style="padding: 4px;">Institution:</label>
      <label style="padding: 4px;">${
        res.data.reportsData[0].organization
      }</label>
      <label style="padding: 4px;">Course:</label>
      <label style="padding: 4px;">${res.data.reportsData[0].course}</label>
      <label style="padding: 4px;">Instructor:</label>
      <label style="padding: 4px;">
        ${res.data.reportsData[0].instruction_names
          .map((e: any) => e.name)
          .join(', ')}
      </label>
      <label style="padding: 4px;">Term:</label>
      <label style="padding: 4px;">${res.data.reportsData[0].term}</label>
    </div>
  </article>
  <!--<footer style="text-align: center; font-size: 14px; line-height: 20px; font-style: italic;">-->
  
  <!--</footer>-->
</main>`;

          asdf(html);
        }
      }
    })
    .catch((error) => {});
};

const getCourseAdministrationByCourse =
  (id: string) => async (dispatch: AppDispatch) => {
    return AdministrationRoute.getCourseAdministrationByCourse(id)
      .then((res: AxiosResponse) => {
        if (res?.data) {
          dispatch(handleGetCourseAdministration(res?.data?.records));
        }
      })
      .catch((err: AxiosError) => {});
  };

const getStudentAndAdministrationByAssessmentId = (
  id: any,
  //cancelToken: any,
  gridRef: any,
  callback: any,
  setLoading: any
) => {
  if (cancelGetStudentsByCourse) {
    cancelGetStudentsByCourse.cancel('Operation canceled by the user.');
  }

  cancelGetStudentsByCourse = axios.CancelToken.source();
  return AdministrationRoute.getStudentAndAdministrationByAssessment(
    id,
    cancelGetStudentsByCourse.token
  )
    .then((result: AxiosResponse) => {
      setLoading(false);
      callback(result);
    })
    .catch((err: AxiosError) => {
      gridRef?.current?.api.setRowData([]);
      gridRef?.current?.api.showNoRowsOverlay();
    });
  // .finally(() => {
  //   if (gridRef?.current) gridRef.current.api.hideOverlay();
  // });
};

// const updateTime = (data: any) => {
//   return AdministrationRoute.changeStartTime(data)
//     .then((result: AxiosResponse) => {
//       if (result.data) {
//
//       }
//     })
//     .catch((error: AxiosError) => {
//
//     });
// };

const updateTime = (
  data: any,
  sendMail: any,
  arr: any,
  bool: any,
  set: any,
  ind: any
) => {
  return AdministrationRoute.changeStartTime(data)
    .then((result: AxiosResponse) => {
      if (result.data) {
        if (moment.utc(data.start_date_time).isBefore(moment.utc())) {
          sendMail(arr, bool, set, ind);
        } else {
          Alert.success({ title: 'Dates saved successfully', text: '' });
        }
      }
    })
    .catch((error: AxiosError) => {});
};
const updateIsActiveStatus = (
  isActive: boolean,
  administrationNo: any,
  courseAssessmentId: any,
  setLoading?: any,
  setRefresh?: any,
  reset?: any
) => {
  const updatedData = {
    id: courseAssessmentId,
    administration_no: administrationNo,
    is_active: isActive,
    reset: reset, // send the reset flag
  };

  // API call to update is_active status in the backend
  AdministrationRoute.changeIsActiveStatus(updatedData)
    .then((result: any) => {
      if (result.data) {
        Alert.success({
          title: `Administration ${
            isActive ? 'Enabled' : 'Disabled'
          } successfully`,
          text: '',
        });
      }
      setLoading(true);
      setRefresh(true);
    })
    .catch((error: any) => {
      Alert.error({ title: 'Error updating status', text: '' });
    });
};

const getResultAnalysis = (
  courseAssessmentId: string,
  downloadReportAnalysis: any
) => {
  return AdministrationRoute.getResultAnalysis(courseAssessmentId)
    .then((result: AxiosResponse) => {
      if (result.data) {
        downloadReportAnalysis(
          result.data.courseInfoData,
          result.data.studentResultsData,
          result.data.administrationSheets
        );
      }
    })
    .catch((error: AxiosError) => {});
};

const getResultAnalysisAdm = (
  courseAssessmentId: string,
  administration_id: string,
  downloadReportAnalysis: any
) => {
  return AdministrationRoute.getResultAnalysisAdm(
    courseAssessmentId,
    administration_id
  )
    .then((result: AxiosResponse) => {
      if (result.data) {
        downloadReportAnalysis(
          result.data.courseInfoData,
          result.data.studentResultsData
        );
      }
    })
    .catch((error: AxiosError) => {});
};

const getTestItemsResultAnalysisAdm = (
  courseAssessmentId: string,
  administration_id: string,
  downloadReportAnalysis: any
) => {
  return AdministrationRoute.getTestItemsResultAnalysisAdm(
    courseAssessmentId,
    administration_id
  )
    .then((result: AxiosResponse) => {
      if (result.data) {
        downloadReportAnalysis(
          result.data.courseInfoData,
          result.data.studentResultsData
        );
      }
    })
    .catch((error: AxiosError) => {});
};

const updateReminderSettings = (
  afterCallSuccess: any,
  afterCallUnSuccess: any,
  data: any
) => {
  AdministrationRoute.changeReminderSetting(data)
    .then((res: AxiosResponse) => {
      afterCallSuccess(res.data);
    })
    .catch((err: AxiosError) => {
      afterCallUnSuccess(err);
    });
};

const saveContentMLearningOValue = (
  afterCallSuccess: any,
  afterCallUnSuccess: any,
  data: any,
  setSubmitting: any
) => {
  AdministrationRoute.changeContentMLearningOValue(data)
    .then((res: AxiosResponse) => {
      afterCallSuccess(data);
    })
    .catch((err: AxiosError) => {
      afterCallUnSuccess(err);
    })
    .finally(() => setSubmitting(false));
};

const studentsBulkDelete = (data: any, getData: any, setBulkStudent: any) => {
  return AdministrationRoute.studentsBulkDelete(data)
    .then((result: AxiosResponse) => {
      if (result.data) {
        setBulkStudent([]);

        getData().then(() => {
          Alert.success({ title: 'Students deleted successfully', text: '' });
        });
      } else {
        Alert.error({
          title: 'Error',
          text: 'Error occurred while deleting students',
        });
      }
    })
    .catch((error: AxiosError) => {});
};

const AdministrationSlice = createSlice({
  name: 'AdministrationSlice',
  initialState,
  reducers: {
    handleGetCourseAdministration: (state, action) => {
      state.getCourseAdministration = action.payload;
    },
    handleLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

//reducers export  to pass action state to reducer type
export const { handleLoading, handleGetCourseAdministration } =
  AdministrationSlice.actions;

//action to calls in ui with dispatch methods
export {
  getCourseAdministrationByCourse,
  getStudentsByCourse,
  getStudentAndAdministrationByAssessmentId,
  updateTime,
  updateIsActiveStatus,
  getReportsData,
  getResultAnalysis,
  getResultAnalysisAdm,
  updateReminderSettings,
  getTestItemsResultAnalysisAdm,
  studentsBulkDelete,
  saveContentMLearningOValue,
};

export default AdministrationSlice.reducer;
